<script lang="ts">
	import { Employee, HTMLText } from '@atoms';
	import { TextStyle } from '@atoms/text/TextStyle';
	import type { EmployeeWithDescriptionBlock } from './EmployeeWithDescriptionBlockQuery';

	const { data }: { data: EmployeeWithDescriptionBlock } = $props();
</script>

<section>
	<div class="left">
		<h2>{data.eyebrow}</h2>
		{#if data.employee}
			<Employee {...data.employee} />
		{/if}
	</div>
	<div class="right">
		<p class="big text:description-large">{data.bigDescription}</p>
		<div class="description">
			<HTMLText text={data.description} style={TextStyle.Medium} />
		</div>
	</div>
</section>

<style lang="scss">
	section {
		padding-bottom: 80px;

		.description {
			width: 100%;

			@include md {
				width: cols(6, 5);
			}
		}

		@include layoutBlockGrid;
		@include md {
			padding-bottom: 62px;
		}

		h2 {
			padding-bottom: 14px;
			margin-bottom: 30px;
			border-bottom: $border;
		}

		.big {
			padding-bottom: 80px;
			@include md {
				padding-bottom: 62px;
			}
		}

		.left {
			display: none;
			@include md {
				display: flex;
				align-self: start;
				flex-direction: column;
				grid-column: 1 / span 2;
			}
		}

		.right {
			display: flex;
			flex-direction: column;
			grid-column: 1 / -1;
			@include md {
				grid-column: 6 / span 6;
			}
		}
	}
</style>
